import React from 'react';
import BrandLogo from '../../assests/images/BrandLogo.png'
import BrandAstraLogo from '../../assests/images/BrandAstraLogo.png'
import { ReactComponent as BrandAstraDarkLogo } from '../../assests/images/LandingAssets/BrandAstraDarkLogo.svg';
import { HeaderDivMain } from '../CompetitiveIntelligence/ViewCompetitive.styled';

const HeaderForInsights = ({margin,theme=false}) => {
    return (
        <HeaderDivMain theme={theme} margin={margin}>
            <div>
            {
                                theme == true ?
                                <img src={`${process.env.PUBLIC_URL}/images/Brand_Astra_White.png` } style={{height:'22px'}} />
                            :

                            <BrandAstraDarkLogo height={'35px'} width={'110px'} />

                            }
                {/* <img src={theme == true ? BrandLogo :BrandAstraLogo} style={{ width: '110px' }} /> */}
            </div>
            <div>
                {/* <h3></h3> */}
                <h3 style={{ color: theme == true ? 'white':'black' , margin: '0px', fontSize: '15px', paddingBottom: '7px' }}>
                    Comprehensive Competitive Analysis
                </h3>
            </div>
        </HeaderDivMain>
    );
};


export default HeaderForInsights;